/* [CARD SWATCHES - NEW]
   Swaps the product card image when a swatch is clicked.
   Uses event delegation so it also works for cards added later
   (infinite scroll, quick view, recently viewed, search results). */
(function () {
  if (window.__cardSwatchesInit) return;
  window.__cardSwatchesInit = true;

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.card_swatch');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    var group = swatch.closest('[data-card-swatches]');
    if (group) {
      group.querySelectorAll('.card_swatch').forEach(function (el) {
        var active = el === swatch;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    var imageUrl = swatch.dataset.variantImage;
    if (!imageUrl) return;

    var card = swatch.closest('.product_block_wrapper, .product_card_wrapper, .recent-product-card');
    if (!card) return;

    var img = card.querySelector('.ratio img:not(.hover_img), .product_card_img img, a img');
    if (!img) return;

    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = imageUrl;
  });
})();
